import React from 'react';
import { intercomAPI, LocalIntercom } from 'ha/modules/Intercom';
import { useServices } from 'ha/services';
import {
  initOptanonWrapper,
  runForRequiredCategories,
  runForNotRequiredCategories,
} from 'ha/modules/OneTrust';
import { isEnabled, useFeatureFlags } from 'ha/modules/FeatureFlags';

interface Props {
  hideIntercom?: boolean;
}

const CookieConsent: React.FC<Props> = ({ hideIntercom }) => {
  const [hasLocalIntercom, setHasLocalIntercom] = React.useState(false);

  const { analytics } = useServices();
  const { lockRudderstackIntegrationsVersion } = useFeatureFlags();

  React.useEffect(() => {
    initOptanonWrapper(() => {
      runForRequiredCategories(() => {
        setHasLocalIntercom(true);
      });

      runForNotRequiredCategories(() => {
        analytics.init({
          withOneTrust: true,
          withIntercom: !hideIntercom,
          lockIntegrationsVersion: isEnabled(
            lockRudderstackIntegrationsVersion,
          ),
        });
      });
    });
  }, [analytics, hideIntercom, lockRudderstackIntegrationsVersion]);

  React.useEffect(() => {
    if (hideIntercom !== false) {
      // `hideIntercom` prop is undefined by default
      // changing it to `true` might have caused unintended events being sent
      // to avoid this, we are explicitly checking for `hideIntercom` to be false
      return;
    }

    if (!hasLocalIntercom) {
      analytics.onIntercomReady(intercomAPI.showLauncher);
    }
  }, [analytics, hasLocalIntercom, hideIntercom]);

  if (hasLocalIntercom) {
    return <LocalIntercom isLauncherVisible={hideIntercom === false} />;
  }

  return null;
};

export { CookieConsent };
